export default __webpack_public_path__ + "static/media/zip11.ffd83dce.txt";